import React from 'react'
import styled from 'styled-components'
import { useControlValue } from '../../Contexts/ControlContext'
import { Header } from './Header'
import { Preview } from './Preview'
import { Button } from '../../Common/Button'
import { copyToClipboard } from '../../Common/CopyToClipboard'
import { Modal } from '../../Common/Modal'




export const Canvas = () => {
	const { openModal, closeModal, controlData } = useControlValue()

	return (
		<div>
			<NavBar>
				<small>Created by:</small>
				<a href="https://designbuffs.com"><img width="50%" src="https://i.ibb.co/2KH0Qd4/designbuffs.png" alt="Design Buffs logo"/></a>
			</NavBar>
			<StyledCanvas>
				<Header />
				<Browser>
					<div className="email-header">
						<span>To: <b>Your Recipient</b></span>
						<span>Subject: <b>Check out my new Email Signature</b></span>
					</div>	
					<Preview />
				</Browser>
				<Button onClick={() => copyToClipboard('signatureMarkup')}>
					Copy HTML
				</Button>
				<Modal showModal={controlData.showModal} openModal={openModal} closeModal={closeModal}>
					<h1>Frequently Asked Questions (FAQ) </h1>
					<h3>How do I use this free email signature generator?</h3>
					<ol>
						<li>Select the template you want to use.</li>	
						<li>Enter your personal information. </li>
						<li>Change the styles & color under the styles tab.</li>
						<li>Copy the HTML and add it to your email client.</li>
					</ol>
					<hr />
					<h3>How do I add my new email signature to Gmail?</h3>
					<ol>
						<li>Log in to your Gmail account, then click the cog in the top right corner.</li>
						<li>Select Settings from the drop down menu.</li>
						<li>Scroll down until you reach the email signature editor, then paste your new email signature there.</li>
						<li>Scroll to the bottom of the page and click 'save changes’.</li>
					</ol>
					<hr />
					<h3>What is an email signature generator?</h3>
					<p>
						An email signature generator is a tool that helps you produce custom email signatures you can add to your email service like Gmail, Outlook, Apple Mail & Co.
						<br/><br/>
						The tool helps you add your name, job title, department, phone number, profile picture, website and multiple social media links.
					</p>

					
				</Modal>	
				<FAQButton onClick={openModal}>FAQs</FAQButton>

			</StyledCanvas>
		</div>
	)
}

const NavBar = styled.nav`
	display: grid;
	max-width: 100vw;
	justify-content: center;
	text-align: center;
	gap: 0.8rem;
	margin-top: 1.5rem;
	padding: 0.2rem;
	img {
		transition: transform .2s ease-in-out;
	}
	img:hover {
		transform: rotate(-7deg);		  
	}
`

const StyledCanvas = styled.article`
	padding: 1rem 3rem;
	grid-area: canvas;
	display: grid;
	place-content: center;
	justify-content: center;

`

const Browser = styled.div`
	display: grid;
	place-content: center;
	width: auto;
	height: auto;
	position: relative;
	padding: 1.0rem;
	border-radius: 4px 4px 0 0;
	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4);
 	margin-bottom: 1.5rem;
	border-top: 32px solid #f5f6f7
	&:before {
		display: block;
		position: absolute;
		content: '';
		top: -20px;
		left: 20px;
		width: 8px;
		height: 8px;
		border-radius: 100%;
		background-color: #FF544D;
		box-shadow: 0 0 0 2px #FF544D, 24px 0 0 2px #FFB62A, 48px 0 0 2px #24C339;
	  }
	}
	.email-header {
		width: 100%;
		display: block;
		background-color: #f5f6f7
		position: absolute;
		span {
			display: block;
			margin: 1.25rem;
		}
		border-top: 1px solid lightgray;		
	}
`

const FAQButton = styled.button`
	position: absolute;
	bottom: 2rem;
	right: 2rem;
	height: 4.5rem;
	width: 4.5rem;
	background-color: #311b92;
	color: white;
	border-radius: 50%;
	font-weight: 600;
	font-size: 0.875rem;
	box-shadow: rgb(0 0 0 / 20%) 0px 3px 4px 0px;
	display: flex;
	-webkit-box-pack: center;
	justify-content: center;
	-webkit-box-align: center;
	align-items: center;
	cursor: pointer;
	text-decoration: none;
`

